var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions-collapsed-list" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-function exit-collapsed-list",
          on: { click: _vm.collapseActions }
        },
        [
          _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.right.hover",
                value: _vm.$t("CANCEL"),
                expression: "$t('CANCEL')",
                modifiers: { right: true, hover: true }
              }
            ],
            staticClass: "glyphicon glyphicon-chevron-left",
            attrs: { "aria-hidden": "true" }
          })
        ]
      ),
      _vm._v(" "),
      _vm.createAccess
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-list-function",
                attrs: { href: _vm.href },
                on: { click: _vm.showForm }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("PING_TREES_ACTIONS_EDIT"),
                      expression: "$t('PING_TREES_ACTIONS_EDIT')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-edit",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PING_TREES_ACTIONS_EDIT",
                      expression: "'PING_TREES_ACTIONS_EDIT'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRingTree.enabled
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.disabled },
                on: {
                  click: function($event) {
                    return _vm.setStatus(false)
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("PING_TREES_ENABLED_TRUE"),
                      expression: "$t('PING_TREES_ENABLED_TRUE')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-media-pause"
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PING_TREES_ENABLED_TRUE",
                      expression: "'PING_TREES_ENABLED_TRUE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.currentRingTree.enabled
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: { disabled: _vm.disabled },
                on: {
                  click: function($event) {
                    return _vm.setStatus(true)
                  }
                }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("PING_TREES_ENABLED_FALSE"),
                      expression: "$t('PING_TREES_ENABLED_FALSE')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-media-play"
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PING_TREES_ENABLED_FALSE",
                      expression: "'PING_TREES_ENABLED_FALSE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin
        ? _c("div", { staticClass: "action-icon" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-list-function",
                attrs: {
                  disabled: _vm.disabled,
                  "data-testid": "ring-tree-delete-button"
                },
                on: { click: _vm.confirmDelete }
              },
              [
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.right.hover",
                      value: _vm.$t("PING_TREES_ACTIONS_DELETE"),
                      expression: "$t('PING_TREES_ACTIONS_DELETE')",
                      modifiers: { right: true, hover: true }
                    }
                  ],
                  staticClass: "typcn typcn-trash",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "PING_TREES_ACTIONS_DELETE",
                      expression: "'PING_TREES_ACTIONS_DELETE'"
                    }
                  ],
                  staticClass: "hint-text-mobile"
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ChangeLogObjectButtonAction", {
        attrs: {
          disabled: _vm.disabled,
          "object-id": _vm.currentRingTree.id,
          "object-name": _vm.currentRingTree.name,
          "object-type": "tree"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }